import { CustomButton } from '@/components/ui/CustomButton';

export const CustomerButton = () => (
  <div className="xl:absolute lg:right-3 xl:right-2 xl:top-0 xl:bottom-3 flex items-center xl:space-x-4">
    {/* Large screen variant */}
    <a href="https://customer.pureretirement.co.uk" target="_blank" rel="nofollow">
      <CustomButton
        variant="primaryMagentaSmall"
        className="hidden lg:block lg:w-[6rem] xl:w-full"
      >
        MyPure Login
      </CustomButton>
    </a>

    {/* Small screen variant */}
    <a href="https://customer.pureretirement.co.uk" target="_blank" rel="nofollow">
      <CustomButton
        variant="primaryMagentaLarge"
        className="block lg:hidden"
      >
        MyPure Login
      </CustomButton>
    </a>
  </div>
);
